import type { AirportScore } from "services/scores";
import { Text } from "@chakra-ui/react";
import type { ColumnDef } from "@tanstack/react-table";
import { SCORE_RANKING_COLORS } from "../../styles";
import type { AirportScoreTableColumns } from "./AirportRankingTable.d";

const rankCellCallback = ({
  row: {
    original: { rank },
  },
}) => (
  <Text as="span" fontSize="sm">
    {rank}.
  </Text>
);

const locationAccessorCallback = (d: {
  dep_city_name: AirportScore["dep_city_name"];
  dep_airport_country_name: AirportScore["dep_airport_country_name"];
}) => `${d.dep_city_name} ${d.dep_airport_country_name}`;

const locationCellCallback = ({
  row: {
    original: { dep_city_name: depCityName, dep_airport_country_name: depAirportCountryName },
  },
}) => <Text as="span" fontSize="sm">{`${depCityName}, ${depAirportCountryName}`}</Text>;

const airportScoreCellCallback = ({
  row: {
    original: { rank, airport_score: airportScore },
  },
}) => (
  <Text
    as="span"
    px={2}
    py={1}
    bg={SCORE_RANKING_COLORS[rank]}
    rounded="5px"
    color="inherit"
    maxW="min-content"
    fontSize="sm"
  >
    {airportScore.toFixed(2)}
  </Text>
);

const columns: ColumnDef<AirportScoreTableColumns>[] = [
  {
    header: "",
    accessorKey: "rank",
    enableSorting: false,
    cell: rankCellCallback,
  },
  { header: "airport", accessorKey: "dep_airport_name", enableSorting: false },
  {
    header: "location",
    accessorFn: locationAccessorCallback,
    enableSorting: false,
    cell: locationCellCallback,
  },
  {
    header: "airhelp_score",
    accessorKey: "airport_score",
    cell: airportScoreCellCallback,
  },
  { header: "on_time_performance", accessorKey: "on_time_performance" },
  { header: "customer_opinion", accessorKey: "skytrax_score" },
  { header: "food_and_shops", accessorKey: "quality_of_retail" },
];

export default columns;
